import TableRow from "../tableRow/TableRow";

import './tableHeader.css';

const TableHeader = ({ headerData }) => {
    return <TableRow styleRow="header" object={headerData} headerData={headerData}/>;
};

export default TableHeader;